module.exports = __webpack_public_path__ + "static/upholstery-430ceef3d17f9506aab79ca44fe78cc9.jpg";